import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import FormCustomer from "../FormCustomer/FormCustomer";

interface ModalProps {
  show: boolean;
  onCancel: () => void;
  customerData: any;
}

const ModalDataCliente: React.FC<ModalProps> = ({ show, onCancel, customerData }) => {
  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal show={show} size="xl" onHide={onCancel}>
      <Modal.Header closeButton style={{ background: "var(--color-profile-1)", color: "black" }}>
        <Modal.Title>Cliente</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormCustomer idCpnj={customerData}/>
      </Modal.Body>
      <Modal.Footer style={{ background: "var(--color-profile-1)" }}>
        <Button
          variant="secondary"
          size="sm"
          disabled={loading}
          onClick={onCancel}
          style={{ display: "flex", alignItems: "center" }}
        >
          {loading ? (
            <Spinner as="span" animation="border" size="sm" />
          ) : (
            <>
              <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: "4px" }} /> Voltar
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalDataCliente;
